export type WorkspaceProvider = "sprites" | "gcp_compute" | "e2b" | "daytona" | "lambda_microvms";

type WorkspaceLike = {
  provider: WorkspaceProvider;
  resourceId: string;
  ownerUserId?: string;
  meta?: Record<string, unknown>;
};

function instanceNameFromResourceId(resourceId: string): string {
  const value = resourceId.trim();
  if (!value) return "";
  if (value.startsWith("projects/")) {
    return value.split("/").pop() || value;
  }
  return value;
}

export function providerLabel(provider: WorkspaceProvider | undefined): string {
  if (provider === "gcp_compute") return "GCP Compute";
  if (provider === "e2b") return "E2B";
  if (provider === "daytona") return "Daytona";
  if (provider === "lambda_microvms") return "AWS Lambda MicroVM";
  if (provider === "sprites") return "Sprites";
  return "Unknown provider";
}

export function workspaceDisplayName(workspace: Pick<WorkspaceLike, "provider" | "resourceId" | "ownerUserId">): string {
  const value = workspace.resourceId.trim();
  if (!value) return workspace.ownerUserId || "";
  if (workspace.provider === "gcp_compute") {
    return instanceNameFromResourceId(value);
  }
  return value;
}

export function workspaceStatusDetail(workspace: WorkspaceLike | null | undefined): string | undefined {
  if (!workspace) return undefined;

  const name = workspaceDisplayName(workspace);
  if (!name) return undefined;

  if (workspace.provider === "gcp_compute") {
    const zone = typeof workspace.meta?.zone === "string" && workspace.meta.zone.trim()
      ? workspace.meta.zone.trim()
      : "";
    return zone ? `${name} · ${zone}` : name;
  }

  return name;
}

export function shortWorkspaceId(
  resourceId: string | null | undefined,
  provider?: WorkspaceProvider,
): string {
  const value = (resourceId || "").trim();
  if (!value) return "";

  if (provider === "gcp_compute" || value.startsWith("projects/")) {
    return instanceNameFromResourceId(value);
  }

  return value.length > 12 ? value.slice(0, 12) : value;
}
